import params from "../../../setup/config/params";
import List from "../List";
import Unsubscribed from "../Unsubscribed/index";

const routes = {
  usersUnsubscribed: {
    path: "/users/unsubscribed",
    exact: true,
    component: Unsubscribed,
    auth: true,
    role: params.user.roles.admin.key,
    module: "engagement",
    subModule: "users",
    action: "canView",
  },

  engagementUsers: {
    path: (page = ":page") => `/users/${page}`,
    activePath: "/users",
    component: List,
    auth: true,
    role: params.user.roles.admin.key,
    module: "engagement",
    subModule: "users",
    action: "canView",
  },
};

export default routes;
